import { uuid } from "@/utils/componentId";
import { getStyle } from '@/utils/style';
import { toPercent } from '@/utils/translate';

export const PLAYER_CONTROL_SIGN = 'playerControl';

const DIRECTIVES = {
  play: { id: 'whPlCmdPlay', name: '播放器-播放', code: '{"cmd":"play"}' },
  pause: { id: 'whPlCmdPause', name: '播放器-暂停', code: '{"cmd":"pause","scope":"global"}' },
  resume: { id: 'whPlCmdResume', name: '播放器-继续', code: '{"cmd":"resume","scope":"global"}' },
  stop: { id: 'whPlCmdStop', name: '播放器-停止', code: '{"cmd":"stop"}' },
  restart: { id: 'whPlCmdRestart', name: '播放器-重播', code: '{"cmd":"restart"}' },
  prev: { id: 'whPlCmdPrev', name: '播放器-节目单上一项', code: '{"cmd":"prev"}' },
  next: { id: 'whPlCmdNext', name: '播放器-节目单下一项', code: '{"cmd":"next"}' },
  playItem: { id: 'whPlCmdPlayItem', name: '播放器-按名称播放', code: '{"cmd":"playItem","name":"文件名.mp4"}' },
  officePrev: { id: 'whPlCmdOfficePrev', name: '播放器-文档上一页', code: '{"cmd":"officePrev"}' },
  officeNext: { id: 'whPlCmdOfficeNext', name: '播放器-文档下一页', code: '{"cmd":"officeNext"}' },
  muteOn: { id: 'whPlCmdMuteOn', name: '播放器-静音', code: '{"cmd":"volume","mute":true}' },
  muteOff: { id: 'whPlCmdMuteOff', name: '播放器-取消静音', code: '{"cmd":"volume","mute":false}' },
  volUp: { id: 'whPlCmdVol50', name: '播放器-音量加', code: '{"cmd":"volume","delta":10}' },
  volDown: { id: 'whPlCmdVol80', name: '播放器-音量减', code: '{"cmd":"volume","delta":-10}' },
  seekBack10: { id: 'whPlCmdSeekBack10', name: '播放器-快退', code: '{"cmd":"seek","delta":-10}' },
  seekFwd10: { id: 'whPlCmdSeekFwd10', name: '播放器-快进', code: '{"cmd":"seek","delta":10}' },
  ptzUp: { id: 'whPlCmdPtzUp', name: '播放器-云台上', code: '{"cmd":"ptz","action":"up"}' },
  ptzDown: { id: 'whPlCmdPtzDown', name: '播放器-云台下', code: '{"cmd":"ptz","action":"down"}' },
  ptzLeft: { id: 'whPlCmdPtzLeft', name: '播放器-云台左', code: '{"cmd":"ptz","action":"left"}' },
  ptzRight: { id: 'whPlCmdPtzRight', name: '播放器-云台右', code: '{"cmd":"ptz","action":"right"}' },
  ptzZoomIn: { id: 'whPlCmdPtzZoomIn', name: '播放器-云台放大', code: '{"cmd":"ptz","action":"zoomIn"}' },
  ptzZoomOut: { id: 'whPlCmdPtzZoomOut', name: '播放器-云台缩小', code: '{"cmd":"ptz","action":"zoomOut"}' },
  ptzStop: { id: 'whPlCmdPtzStop', name: '播放器-云台停止', code: '{"cmd":"ptz","action":"stop"}' },
};

/** 按压切换：第一次静音，第二次取消静音（指令 + 指令2，关闭单击模式） */
const MUTE_TOGGLE_OPTS = { toggleKey: 'muteOff', btnPressName: '取消静音' };

function makeDirective(spec, order) {
  return {
    temId: Date.now() + Math.random(),
    id: spec.id,
    instruction_name: spec.name,
    instruction_code: spec.code,
    send_type: 'tcpip',
    unicode: '1',
    enterSpace: '3',
    return_code: '',
    ip: '0.0.0.0',
    port: '19082',
    delay: '0',
    counts: '1',
    order: order || 1,
    mustValid: '',
  };
}

function applyGroupChildLayout(btn, relLeft, relTop, groupW, groupH) {
  btn.style.left = relLeft;
  btn.style.top = relTop;
  const base = getStyle(btn.style);
  btn.groupStyle = {
    ...base,
    left: toPercent(relLeft / groupW),
    top: toPercent(relTop / groupH),
    width: toPercent(btn.style.width / groupW),
    height: toPercent(btn.style.height / groupH),
  };
}

function makeButton(label, specKey, relLeft, relTop, btnW, btnH, order, groupW, groupH, buttonOpts = {}) {
  const spec = DIRECTIVES[specKey];
  const toggleSpec = buttonOpts.toggleKey ? DIRECTIVES[buttonOpts.toggleKey] : null;
  const isToggle = !!toggleSpec;
  const btn = {
    component: 'v-button',
    type: 'square',
    label: '方形按钮',
    propValue: label,
    icon: 'button',
    id: uuid(),
    events: {
      mutuallyEvent: [],
      jumpEvent: [],
      pressEvent: [],
      pressAgainEvent: [],
      clickEvent: { comp: '', event: '' },
    },
    networkConfig: {
      directives: [makeDirective(spec, order)],
      directives2: toggleSpec ? [makeDirective(toggleSpec, order)] : [],
      ipAdress: '',
      port: '',
    },
    componentLinks: {
      links: [
        {
          id: uuid(),
          comp: '',
          listenEvent: '',
          changeAttrs: [{ id: uuid(), key: '', value: undefined }],
        },
      ],
      transitionTime: '',
    },
    style: {
      width: btnW,
      height: btnH,
      top: relTop,
      left: relLeft,
      fontSize: 14,
      fontWeight: 500,
      oneClick: !isToggle,
      modalConfirm: false,
      backgroundColor: '#409eff',
      pressBackgroundColor: '#ffff00',
      color: '#ffffff',
      border: 'none',
      pressRing: false,
      btnPressName: buttonOpts.btnPressName || '',
      btnLoading: false,
      btnLoadingTime: 5,
      kqds: false,
      alias: label,
      backgroundType: 'color',
      pressBackgroundType: 'color',
      backgroundImage: '',
      pressBackgroundImage: '',
      backgroundInfo: {},
      pressBackgroundImageInfo: {},
      btnIcon: '',
      rotate: 0,
      opacity: 1,
      borderRadius: 0,
      fontFamily: '',
    },
    animations: [],
    timeingEnable: '',
    groupStyle: {},
    isLock: false,
  };
  applyGroupChildLayout(btn, relLeft, relTop, groupW, groupH);
  return btn;
}

export const PLAYER_PTZ_TEMPLATE_KEY = 'player-ptz';

export const playerControlOptions = [
  { key: 'player-playback', label: '播放控制条' },
  { key: 'player-playlist', label: '节目单切换条' },
  { key: 'player-page', label: '文档翻页条' },
  { key: 'player-volume', label: '音量控制条' },
  { key: PLAYER_PTZ_TEMPLATE_KEY, label: '网络摄像头云台' },
  { key: 'player-full', label: '完整控制条' },
];

export const PLAYER_CONTROL_BUTTON_COUNTS = {
  'player-playback': 5,
  'player-playlist': 2,
  'player-page': 2,
  'player-volume': 3,
  'player-ptz': 7,
  'player-full': 14,
};

const TEMPLATES = {
  'player-playback': {
    label: '播放器-播放控制',
    buttons: [
      ['播放', 'play'],
      ['暂停', 'pause'],
      ['继续', 'resume'],
      ['停止', 'stop'],
      ['重播', 'restart'],
    ],
  },
  'player-playlist': {
    label: '播放器-节目单切换',
    buttons: [
      ['上一项', 'prev'],
      ['下一项', 'next'],
    ],
  },
  'player-page': {
    label: '播放器-文档翻页',
    buttons: [
      ['上一页', 'officePrev'],
      ['下一页', 'officeNext'],
    ],
  },
  'player-volume': {
    label: '播放器-音量控制',
    buttons: [
      ['静音', 'muteOn', MUTE_TOGGLE_OPTS],
      ['音量+', 'volUp'],
      ['音量-', 'volDown'],
    ],
  },
  'player-ptz': {
    label: '播放器-网络摄像头云台',
    rowSplit: 4,
    buttons: [
      ['上', 'ptzUp'],
      ['左', 'ptzLeft'],
      ['停', 'ptzStop'],
      ['右', 'ptzRight'],
      ['下', 'ptzDown'],
      ['放大', 'ptzZoomIn'],
      ['缩小', 'ptzZoomOut'],
    ],
  },
  'player-full': {
    label: '播放器-完整控制',
    /** 第一排 7 个，第二排 7 个 */
    rowSplit: 7,
    buttons: [
      ['播放', 'play'],
      ['暂停', 'pause'],
      ['继续', 'resume'],
      ['停止', 'stop'],
      ['重播', 'restart'],
      ['快退', 'seekBack10'],
      ['快进', 'seekFwd10'],
      ['静音', 'muteOn', MUTE_TOGGLE_OPTS],
      ['上一页', 'officePrev'],
      ['下一页', 'officeNext'],
      ['上一项', 'prev'],
      ['下一项', 'next'],
      ['音量+', 'volUp'],
      ['音量-', 'volDown'],
    ],
  },
};

export function buildPlayerControlGroup(templateKey, dropLeft, dropTop) {
  const tpl = TEMPLATES[templateKey] || TEMPLATES['player-playback'];
  const btnW = 84;
  const btnH = 36;
  const gap = 8;
  const pad = 6;
  const entries = tpl.buttons;
  const rowSplit = tpl.rowSplit > 0 && tpl.rowSplit < entries.length ? tpl.rowSplit : entries.length;
  const row1 = entries.slice(0, rowSplit);
  const row2 = entries.slice(rowSplit);
  const layoutRows = row2.length ? [row1, row2] : [row1];
  const maxCols = Math.max(...layoutRows.map((row) => row.length));
  const groupW = pad * 2 + maxCols * btnW + (maxCols - 1) * gap;
  const groupH =
    pad * 2 + layoutRows.length * btnH + (layoutRows.length - 1) * gap;
  const baseLeft = Math.max(0, dropLeft || 0);
  const baseTop = Math.max(0, dropTop || 0);
  let order = 1;
  const children = [];
  layoutRows.forEach((row, rowIdx) => {
    row.forEach((entry, colIdx) => {
      const [label, specKey, buttonOpts] = entry;
      const relLeft = pad + colIdx * (btnW + gap);
      const relTop = pad + rowIdx * (btnH + gap);
      children.push(
        makeButton(label, specKey, relLeft, relTop, btnW, btnH, order++, groupW, groupH, buttonOpts)
      );
    });
  });
  return {
    id: uuid(),
    component: 'Group',
    label: tpl.label,
    propValue: children,
    style: {
      width: groupW,
      height: groupH,
      top: baseTop,
      left: baseLeft,
      rotate: 0,
      opacity: 1,
    },
    animations: [],
    timeingEnable: '',
    groupStyle: {},
    isLock: false,
  };
}
